import { render } from "./FoodImageLoader.vue?vue&type=template&id=5393191a"
import script from "./FoodImageLoader.vue?vue&type=script&lang=js"
export * from "./FoodImageLoader.vue?vue&type=script&lang=js"

import "./FoodImageLoader.vue?vue&type=style&index=0&id=5393191a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__